"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderBar = exports.PageHeaderBarDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var page_header_navigation_1 = require("./page-header-navigation");
var use_sidebar_1 = require("../../hooks/use-sidebar");
var sidebar_menu_button_1 = require("./sidebar-menu-button");
exports.PageHeaderBarDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    height: 51px;\n    width: 100%;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    background: ", ";\n//    box-shadow: 0px 1px 0px rgba(0,0,0,0.9);\n    -webkit-user-select: none;\n    -webkit-app-region: drag;\n\n    button {\n      -webkit-app-region: no-drag;\n    }\n  "], ["\n    display: flex;\n    height: 51px;\n    width: 100%;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    background: ", ";\n//    box-shadow: 0px 1px 0px rgba(0,0,0,0.9);\n    -webkit-user-select: none;\n    -webkit-app-region: drag;\n\n    button {\n      -webkit-app-region: no-drag;\n    }\n  "])), theme_1.theme.COLOR('app-chrome')),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: 56px;\n  "], ["\n    height: 56px;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: 60px;\n  "], ["\n    height: 60px;\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    align-self: stretch;\n    justify-self: stretch;\n    align-items: center;\n    flex-direction: row;\n  "], ["\n    display: flex;\n    width: 100%;\n    align-self: stretch;\n    justify-self: stretch;\n    align-items: center;\n    flex-direction: row;\n  "])))
});
var NavigationStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-right: ", ";\n    padding-left: ", ";\n  "], ["\n    margin-right: ", ";\n    padding-left: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2)),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n    padding-left: ", ";\n  "], ["\n    ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n    padding-left: ", ";\n  "])), theme_1.theme.V_DOT_BG(), theme_1.theme.UNIT(2), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4))
});
var SidebarMenuButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    flex-shrink: 0;\n    cursor: pointer;\n    margin-left: ", ";\n    margin-right: ", ";\n  "], ["\n    flex-shrink: 0;\n    cursor: pointer;\n    margin-left: ", ";\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4)),
  desktop: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.header(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  SidebarMenuButton: (0, styled_components_1.default)(sidebar_menu_button_1.SidebarMenuButton)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), SidebarMenuButtonStyles),
  Navigation: (0, styled_components_1.default)(page_header_navigation_1.PageHeaderNavigation)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), NavigationStyles)
};
var PageHeaderBar = function (props) {
  var className = props.className,
    children = props.children,
    ref = props.ref;
  var _a = (0, use_sidebar_1.useSidebar)(),
    state = _a.state,
    show = _a.show,
    isFloating = _a.isFloating;
  var isShown = state.isShown;
  // console.log(state);
  return react_1.default.createElement(My.Container, {
    ref: ref,
    className: className
  }, react_1.default.createElement(My.Body, null, (!isShown || isFloating) && react_1.default.createElement(My.SidebarMenuButton, {
    className: "platform-menu-button-closed",
    onClick: show
  }), children), react_1.default.createElement(My.Navigation, null));
};
exports.PageHeaderBar = PageHeaderBar;
exports.PageHeaderBar.defaultProps = exports.PageHeaderBarDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;